<template>
	<c-dialog ref="dialog" width="1200" mode="slide" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
      <c-form-item :label="false" name="attribute_list" colspan="2">
        <m-operate border>
          <c-button color="main" prepend-icon="tf-add" @click="addRow()">添加父级属性</c-button>
        </m-operate>
        <c-table ref="attribute_table" border :paging="false">
          <c-table-column label="父级属性" width="150">
            <template #default="{data}">
              <c-select name="spu_category"
                        async @search="searchAttribute"
                        @change="changeAttribute(data,arguments[0])"
                        :value-data="data.attributeName"
                        v-model="data.attribute_parent_id"
                        :clear="false">
                <template #option="{data, selected}">
                  <select-option :name="data.name" :selected="selected"></select-option>
                </template>
              </c-select>
            </template>
          </c-table-column>
          <c-table-column label="是否必填" width="50">
            <template #default="{data}">
                <c-select :options="requiredOptions" name="required" v-model="data.required"></c-select>
            </template>
          </c-table-column>

          <c-table-column label="子级属性" width="300">
            <template #default="{data}">
              <c-select name="spu_brand"
                        async multiple @search="searchAttributeValue(data,arguments[0], arguments[1])"
                        :value-data="data.attributeValue"
                        :disabled = "data.attribute_type != 4 || !data.attribute_parent_id"
                        v-model="data.attribute_ids"
                        :clear="false">
                <template #option="{data, selected}">
                  <select-option :name="data.name" :selected="selected"></select-option>
                </template>
              </c-select>
            </template>
          </c-table-column>
          <c-table-column type="button" label="操作" width="80">
            <template #default="row">
              <c-table-button icon="tf-trash" color="red" @click="row.remove();">删除</c-table-button>
            </template>
          </c-table-column>
        </c-table>
      </c-form-item>
    </c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
	computed: {
	},
	
	data() {
		return {
            modelId:0,    //型号ID
            requiredOptions: [
                {name: '非必填',value:0,color: 'gray'},
                {name: '必填',value: 1,color: 'green'}
            ],
            model_attribute_type:1//类型 0：toC端，1：toB端
        }
	},
  watch: {
  },

	methods: {
    /*******搜索父属性*****************/
    searchAttribute(keyword, resolve){
      this.request({
        url:'/spu/attribute/options',
        data: {
            keyword: keyword
        },
        success:data => {
            resolve(data);
        }
      })
    },
    /********变更父级属性*************/
    changeAttribute(rowData,{data}){
      rowData.attribute_type = data.attribute_type;
      //清空子项信息
      rowData.attributeValue = [];
      rowData.attribute_ids = [];
    },
    /*******搜索子属性*****************/
    searchAttributeValue(data,keyword, resolve){
      this.request({
        url:'/spu/attribute/value/options',
        data: {
            parent_id:data.attribute_parent_id||0,
            keyword: keyword
        },
        success:data => {
            resolve(data);
        }
      })
    },
    /*******查询型号关联的SKU配置详情*****************/
    getModelSKUList(type,id){
      this.request({
        url:'/spu/model/sku/config',
        data: {
            id: id,
            type:type
        },
        success:data => {
            this.$refs.attribute_table.setData(data||[])
        }
      });
    },
		/*********打开编辑框，初始化**********/
    open(type,data) {
        this.model_attribute_type = type;
        this.modelId = data.id;
        this.getModelSKUList(this.model_attribute_type,this.modelId);
        //填充form表单
        this.$refs.dialog.open({
        title:((type==0?'C端':'B端'))+' - 型号【'+data.model_name+'】SKU配置 - '
        });
    },

    /******添加行数据*********/
    addRow() {
      var rowData = {};
      rowData.attribute_parent_id = 0;//父级属性ID
      rowData.required = 0;           //是否必填
      rowData.attribute_ids = [];     //属性ID
      this.$refs.attribute_table.push(rowData)
    },
    /**
     * 校验数组中 attribute_parent_id 是否唯一
     * @param arr 对象数组
     * @return true：无重复；false：存在重复
     */
    checkAttrParentIdUnique(arr) {
        const idList = arr.map(item => item.attribute_parent_id);
        // filter：找出所有重复出现的id元素
        const repeatItems = idList.filter((id, index, array) => {
          // 当前id第一次出现的下标 !== 当前下标 → 该id重复了
          return array.indexOf(id) !== index;
        });
        // 重复数组长度大于0 = 有重复，返回false；反之true
        return repeatItems.length === 0;
    },
		/*******添加、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
      let flag = true;
      var attribute_list = this.$refs.attribute_table.getData();
      if (!attribute_list || attribute_list.length == 0){
          this.$message({
            type: 'fail',
            message: '请至少添加一行属性数据'
          });
          flag = false;
          return;
      }
      if (!this.checkAttrParentIdUnique(attribute_list)){
          this.$message({
            type: 'fail',
            message: '父级属性重复，请删除或修改'
          });
          flag = false;
          return;
      }
      for (let i=0;i<attribute_list.length;i++){
        var obj = attribute_list[i];
        if (!obj.attribute_parent_id || obj.attribute_parent_id == 0){
          this.$message({
            type: 'fail',
            message: '请完善父级属性'
          });
          flag = false;
          return;
        }
        if (obj.attribute_type == 4 && (!obj.attribute_ids || obj.attribute_ids.length == 0)){
          this.$message({
            type: 'fail',
            message: '请完善子级属性'
          });
          flag = false;
          return;
        }
      }
      if (flag){
          this.request({
            url:'/spu/model/sku/config/edit',
            data: {
              type: this.model_attribute_type,
              id: this.modelId,
              attribute_list:attribute_list
            },
            success:data => {
                next();
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
            }
          });
      }
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>